import React from "react";
import classNames from "classnames";
import { cva } from "class-variance-authority";
import { Link } from "react-router-dom";

const NavLinkVariants = cva(
  /* button base style */
  `font-poppins font-normal outline-none border-none`,
  {
    variants: {
      /* button colors */
      intent: {
        primary: "bg-accent-silver-900 text-white inline-block",
        secondary: "bg-secondary text-white inline-block",
        accent: "inline underline-none",
        default: "bg-accent-silver-900 text-white inline-block",
      },

      /* button sizes */
      size: {
        sm: ["text-sm", "py-2", "px-4"],
        md: ["text-base", "py-2", "px-8"],
        lg: ["text-sm", "py-2", "px-12"],
      },

      /* button roundness */
      roundness: {
        square: "rounded-none",
        "round-sm": "rounded-md",
        "round-md": "rounded-lg",
        "round-lg": "rounded-3xl",
      },
    },

    // defaults
    defaultVariants: {
      intent: "default",
      size: "lg",
      roundness: "round-lg",
    },
  }
);

const NavLink = ({
  intent,
  type,
  size,
  roundness,
  eventAction,
  classes,
  name,
  href,
  label,
}) => {
  return (
    <Link
      to={href}
      className={classNames(
        NavLinkVariants({ intent, size, roundness }, classes),
        ...classes
      )}
    >
      {label}
    </Link>
  );
};

export default NavLink;
